import React from 'react';

// Encabezado de página del lenguaje nuevo: título en Bricolage, descripción breve y acciones a la derecha.
export default function PageHeader({ title, subtitle, children }) {
  return (
    <div className="mb-7 flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        <h1 className="font-display text-[30px] sm:text-[34px] leading-[1.08] font-bold text-fg">{title}</h1>
        {subtitle && <p className="mt-1.5 text-[14.5px] text-fg-dim max-w-[64ch]">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}
